import { render, staticRenderFns } from "./LanguangeSwitcher2.vue?vue&type=template&id=fbfcb576&scoped=true"
import script from "./LanguangeSwitcher2.vue?vue&type=script&lang=js"
export * from "./LanguangeSwitcher2.vue?vue&type=script&lang=js"
import style0 from "./LanguangeSwitcher2.vue?vue&type=style&index=0&id=fbfcb576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfcb576",
  null
  
)

export default component.exports